import { useContext } from 'react';
import GeneralContext from '../context/generalContext/GeneralContext';
const UseGeneralContext = () => {
  return useContext(GeneralContext);
};

export default UseGeneralContext;
